import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { MortgageApplication } from './../../../models/mortgage-application.model';

@Component({
  selector: 'boi-sort-code-input',
  templateUrl: './sort-code-input.component.html',
  styleUrls: ['./sort-code-input.component.scss']
})
export class SortCodeInputComponent {
  public sortCode1: number;
  public sortCode2: number;
  public sortCode3: number;
  public hasErrors: boolean;
  public referenceDataLabels = ReferenceDataLabels;

  private _mortgageApplication: MortgageApplication;

  public get mortgageApplication(): MortgageApplication {
    return this._mortgageApplication;
  }

  @Input() public set mortgageApplication(value: MortgageApplication) {
    this._mortgageApplication = value;
    this.sortCode1 = !value.SortCode1 ? undefined : Number(value.SortCode1);
    this.sortCode2 = !value.SortCode2 ? undefined : Number(value.SortCode2);
    this.sortCode3 = !value.SortCode3 ? undefined : Number(value.SortCode3);
  }

  sortCodeChange(event): void {
    const isSelected = event.target.selectionEnd - event.target.selectionStart > 0;
    if (event.target.value.length >= 2 && !isSelected) {
      event.preventDefault();
    }
  }
}
